Ext.define('SA.ModeIndicator', {
    singleton: true,

    initialize() {
        this.el = document.body.appendChild(document.createElement('div'));
        this.el.classList.add('sa-mode-indicator');
        this.el.innerHTML = '<div class="sa-mode-indicator-text"></div>';

        this.textEl = this.el.querySelector('.sa-mode-indicator-text');

        this.set({text: '', visible: false});
    },

    set({text, visible}) {
        this.textEl.textContent = text;

        this.el.style.display = visible ? null : 'none';
    }
});